module.exports = __webpack_public_path__ + "static/media/NotepadEnviro.78cdbd6a.jpg";